import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Stack } from '@mui/material';
import { useState } from 'react';

import { ProfesionalSelect } from '@/features/profesionales/components/ProfesionalSelect';

import { CrearProfesionalDialog } from './CrearProfesionalDialog';

interface ProfesionalFieldWithCreateProps {
  value: string;
  onChange: (uid: string) => void;
  error?: boolean;
  helperText?: string;
}

export function ProfesionalFieldWithCreate({
  value,
  onChange,
  error,
  helperText,
}: ProfesionalFieldWithCreateProps): JSX.Element {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Box sx={{ flex: 1 }}>
          <ProfesionalSelect
            label="Profesional"
            required
            value={value}
            onChange={(e) => onChange(e.target.value as string)}
            error={error}
            helperText={helperText}
          />
        </Box>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => setDialogOpen(true)}
          sx={{ mt: 0.5, whiteSpace: 'nowrap' }}
        >
          Crear nuevo
        </Button>
      </Stack>
      <CrearProfesionalDialog
        open={dialogOpen}
        onCreated={(uid) => {
          onChange(uid);
          setDialogOpen(false);
        }}
        onCancel={() => setDialogOpen(false)}
      />
    </Box>
  );
}
